import * as z from "zod/v4";
import { ProfileDateRangeSchema } from "./profile-date-range.js";
import { ProfilePaginationSchema } from "./profile-pagination.js";
import { ProfileSearchFiltersSchema } from "./profile-search-filters.js";
const ListProfilesRequestSchema_ = z.object({
    merchantId: z.string(),
    dateRange: ProfileDateRangeSchema,
    search: ProfileSearchFiltersSchema.optional(),
    optInEmails: z.boolean().optional(),
    pagination: ProfilePaginationSchema.optional(),
});
export const ListProfilesRequestSchema = ListProfilesRequestSchema_;
//# sourceMappingURL=list-profiles-request.js.map